import { render, staticRenderFns } from "./CreateFooter.vue?vue&type=template&id=54013a89&scoped=true"
import script from "./CreateFooter.vue?vue&type=script&lang=ts"
export * from "./CreateFooter.vue?vue&type=script&lang=ts"
import style0 from "./CreateFooter.vue?vue&type=style&index=0&id=54013a89&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54013a89",
  null
  
)

export default component.exports